var map = {
	"./patch_notes/temp_delete_me.png": [
		74352,
		804
	],
	"./patch_notes/v283/shifting_content_after.png": [
		71130,
		804
	],
	"./patch_notes/v283/shifting_content_before.png": [
		37207,
		804
	],
	"./patch_notes/v283/shuffle_card_after.png": [
		13048,
		804
	],
	"./patch_notes/v283/shuffle_card_before.png": [
		63593,
		804
	],
	"./patch_notes/v283/stop-achievements-blocking-after.png": [
		63977,
		804
	],
	"./patch_notes/v283/stop-achievements-blocking-before.png": [
		32534,
		804
	],
	"./patch_notes/v284/android_status_bar_after.png": [
		52745,
		804
	],
	"./patch_notes/v284/android_status_bar_before.png": [
		83446,
		804
	],
	"./patch_notes/v284/city_improvement_mobile_after.png": [
		22578,
		804
	],
	"./patch_notes/v284/city_improvement_mobile_before.png": [
		10479,
		804
	],
	"./patch_notes/v284/counter_offer_8p_after.png": [
		48071,
		804
	],
	"./patch_notes/v284/counter_offer_8p_before.png": [
		40136,
		804
	],
	"./patch_notes/v284/trade_counter_offer_after.png": [
		35563,
		804
	],
	"./patch_notes/v284/trade_counter_offer_before.png": [
		66460,
		804
	],
	"./patch_notes/v286/bot_kick_confirmation_before.png": [
		74862,
		804
	],
	"./patch_notes/v286/room_guests_after.png": [
		31338,
		804
	],
	"./patch_notes/v286/room_guests_before.png": [
		63751,
		804
	],
	"./patch_notes/v287/ios_dice_resolution_after.png": [
		41816,
		804
	],
	"./patch_notes/v287/ios_dice_resolution_before.png": [
		41001,
		804
	],
	"./patch_notes/v287/mobile_endgame_after.png": [
		62814,
		804
	],
	"./patch_notes/v287/mobile_endgame_before.png": [
		5675,
		804
	],
	"./patch_notes/v288/new_badge_after.png": [
		75577,
		804
	],
	"./patch_notes/v288/new_badge_before.png": [
		8678,
		804
	],
	"./patch_notes/v289/fix_pixelated_fullscreen_popup_after.png": [
		68905,
		804
	],
	"./patch_notes/v289/fix_pixelated_fullscreen_popup_before.png": [
		96950,
		804
	],
	"./patch_notes/v289/group_owned_maps_after.png": [
		46873,
		804
	],
	"./patch_notes/v289/group_owned_maps_before.png": [
		85606,
		804
	],
	"./patch_notes/v289/message_appears_without_username_avatar_after.png": [
		90416,
		804
	],
	"./patch_notes/v289/message_appears_without_username_avatar_before.png": [
		14433,
		804
	],
	"./patch_notes/v289/rename_lobby_to_room_after.png": [
		27935,
		804
	],
	"./patch_notes/v289/rename_lobby_to_room_before.png": [
		47168,
		804
	],
	"./patch_notes/v289/update_payment_successful_popup_after.png": [
		72236,
		804
	],
	"./patch_notes/v289/update_payment_successful_popup_before.png": [
		71181,
		804
	],
	"./patch_notes/v292/portrait_new_top_bar_after.png": [
		91766,
		804
	],
	"./patch_notes/v292/portrait_new_top_bar_before.png": [
		64483,
		804
	],
	"./patch_notes/v293/new_leaderboard_icon_after.png": [
		20175,
		804
	],
	"./patch_notes/v293/new_leaderboard_icon_before.png": [
		15568,
		804
	],
	"./patch_notes/v293/page_scrolling_after.png": [
		65364,
		804
	],
	"./patch_notes/v293/page_scrolling_before.png": [
		92437,
		804
	],
	"./patch_notes/v295/checkout_button_after.png": [
		79754,
		804
	],
	"./patch_notes/v295/checkout_button_before.png": [
		25735,
		804
	],
	"./patch_notes/v295/new_game_mode_icons_after.gif": [
		2638,
		804
	],
	"./patch_notes/v295/new_game_mode_icons_before.gif": [
		68525,
		804
	],
	"./patch_notes/v295/portrait-player-info-before.png": [
		90720,
		804
	],
	"./patch_notes/v295/portrait-player-info-new.gif": [
		32560,
		804
	],
	"./patch_notes/v295/portrait-player-info-new.png": [
		25827,
		804
	],
	"./patch_notes/v295/store_popup_tablet_after.png": [
		20296,
		804
	],
	"./patch_notes/v295/store_popup_tablet_before.png": [
		42521,
		804
	],
	"./patch_notes_images/dang-fix-pixelated-fullscreen-popup-image-after.png": [
		77247,
		804
	],
	"./patch_notes_images/dang-fix-pixelated-fullscreen-popup-image-before.png": [
		24160,
		804
	],
	"./patch_notes_images/dang-increase-end-game-size-after.png": [
		20065,
		804
	],
	"./patch_notes_images/dang-increase-end-game-size-before.png": [
		77422,
		804
	],
	"./patch_notes_images/dang-update-payment-successful-popup-after.png": [
		37414,
		804
	],
	"./patch_notes_images/dang-update-payment-successful-popup-before.png": [
		72179,
		804
	],
	"./patch_notes_images/message-appears-without-username-avatar-after.png": [
		70653,
		804
	],
	"./patch_notes_images/message-appears-without-username-avatar-before.png": [
		75466,
		804
	],
	"./patch_notes_images/rename-lobby-to-room-after.png": [
		6734,
		804
	],
	"./patch_notes_images/rename-lobby-to-room-before.png": [
		48027,
		804
	],
	"./patch_notes_images/stan-fix-safari-low-resolution-dice-after.jpg": [
		64428,
		804
	],
	"./patch_notes_images/stan-fix-safari-low-resolution-dice-before.jpg": [
		25873,
		804
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 88341;
module.exports = webpackAsyncContext;